import PropTypes from "prop-types";

// material-ui
import { useTheme } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";

// project imports
import NavItem from "../NavItem";
import NavCollapse from "../NavCollapse";
import { observer } from "mobx-react";
import layout_store from 'layouts/MainLayout/store'
import {useEffect} from "react";

// КОНСТАНТА С МЕНЮ - ЖЕСТКО ПРОПИСАНО
const MENU_ITEMS = [
  {
    id: "ApprovalRequest",
    title: "Заявки на согласование",
    type: "item",
    // icon: icons.IconFileText,
    url: "/user/ApprovalRequest"
  },
  {
    id: "Organization",
    title: "Организации",
    type: "item",
    // icon: icons.IconBuilding,
    url: "/user/Organization"
  },
    {
        id: "MyOrganization",
        title: "Моя организация",
        type: "item",
        // icon: icons.IconBuilding,
        url: "/user/MyOrganization"
    },
        {
        id: "MyApprovalRequests",
        title: "Моя заявки",
        type: "item",
        // icon: icons.IconBuilding,
        url: "/user/MyApprovalRequests"
    }
];

// ==============================|| SIDEBAR MENU LIST GROUP ||============================== //

const NavGroup = observer(({ item, isSuperAdmin }) => {
  const theme = useTheme();
    useEffect(() => {
    }, [layout_store.isSuperAdmin]);

  // ИСПОЛЬЗУЕМ КОНСТАНТУ
  const menuItems = MENU_ITEMS.filter(menu => {
      if (menu.id === "Organization" && !layout_store.isSuperAdmin) {
          return false;
      }
      if (menu.id === "MyOrganization" && !layout_store.isAdmin) {
          return false;
      }
      return true;
  });

  const items = menuItems.map((menu) => {
    switch (menu.type) {
      case 'collapse':
        return <NavCollapse key={menu.id} menu={menu} level={1} />;
      case 'item':
        return <NavItem key={menu.id} item={menu} level={1} />;
      default:
        return (
          <Typography key={menu.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
    }
  });

  return (
    <>
      <List>
        {items}
      </List>
      <Divider sx={{ mt: 0.25, mb: 1.25 }} />
    </>
  );
});

NavGroup.propTypes = {
  item: PropTypes.object,
  isSuperAdmin: PropTypes.bool
};

export default NavGroup;